import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { getSelectedParticipants } from '@app/modules/performance/functions';
import { AnalyticService } from '@app/services';
import { NotifyService } from '@app/services/notify.service';
import { StoreView } from '@common/views';
import { Survey } from '@models/performance/survey.model';

@Component({
    templateUrl: './survey-store.template.html',
    styleUrls: ['./survey-store.style.scss'],
})
export class SurveyStoreView extends StoreView {
    isLoading = false;
    survey: Survey;
    participants: Map<number, boolean> = new Map<number, boolean>();

    constructor(
        private location: Location,
        private analyticService: AnalyticService,
        private notify: NotifyService
    ) {
        super();
        this.survey = new Survey({});
    }

    onSave(): void {
        this.isLoading = true;

        this.survey
            .attach('participants', getSelectedParticipants(this.participants))
            .save()
            .then(() => {
                this.notify.success('surveys.store.surveySummaryForm.surveyCreated');
                this.location.back();

                this.analyticService.trackEvent(AnalyticEvents.SurveysCreateSurveySave);
            })
            .catch((err) => {
                this.isLoading = false;
                this.notify.error(err);
            });
    }
}
